export default __webpack_public_path__ + "static/media/5.cc765ff7.png";